import styles from "./css/announcement.module.css"

export const AnnouncementBox = () => {

    return(
        <div className={`${styles.font} ${styles.px4} ${styles.mdpx8} ${styles.pt2} ${styles.box} `}>
            <div className={`${styles.lgp} ${styles.round} ${styles.bg} ${styles.box} ${styles.wfull}  ${styles.flexrow} ${styles.flex} ${styles.flexwrap} ${styles.itemcenter} ${styles.contentcenter} ${styles.p3}`}>
             <a href="" target="_blank" className={`${styles.roundfull} ${styles.extrabold} ${styles.textnone} ${styles.box} ${styles.greenbtn} ${styles.py3} ${styles.px8}`}>Announcement</a>
             <div className={`${styles.box} ${styles.flex} ${styles.itemcenter} ${styles.wfull} ${styles.px8} ${styles.pt3}`}>
              <p className={`${styles.lgp} ${styles.line} ${styles.wfull} ${styles.textcenter} ${styles.fontsemibold} ${styles.textblack}`}>
              {""}🙌 $6.7M in fresh funding to build the next-gen developer blogging community. {""}
              <a href="" target="_blank" rel="noopener" className={`${styles.box} ${styles.inlineblock} ${styles.textnone} ${styles.textbrandblue}`}>Learn more</a>
              </p>
            </div>
            </div>
            
        </div>
    )
}